// Swaps search placeholder based on screen size
navbarSearchPlaceholder = function() {

    if ($(window).width() <= 576) {
        $('#site-search').attr('placeholder', 'Search');
    } else {
        $('#site-search').attr('placeholder', 'Search Resources');
    }

};
navbarSearchPlaceholder();

$(window).resize(function() {
    navbarSearchPlaceholder();
});